export default "__VITE_ASSET__CvyB5fy0__"